import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-foreground-950 font-heading font-bold text-2xl md:text-3xl lg:text-4xl inline-flex items-center gap-3">
            <span className="text-primary-400 font-heading text-3xl md:text-4xl">〔</span>
            瓜友热评
            <span className="text-primary-400 font-heading text-3xl md:text-4xl">〕</span>
          </h2>
        </div>

        <div className="space-y-10 md:space-y-14">
          {commentItems.map((item, idx) => (
            <div key={idx}>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 mt-0.5">
                  <span className="inline-flex items-center gap-1 bg-foreground-900 text-accent-400 px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {item.rating}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="relative">
                    <span className="absolute -left-1 -top-1 text-primary-300 font-heading text-4xl md:text-5xl leading-none select-none">&ldquo;</span>
                    <p className="text-foreground-700 text-sm md:text-base leading-relaxed pl-6 mb-4">
                      {item.text}
                    </p>
                  </div>
                  <div className="flex items-center gap-3 pl-6">
                    <div className="w-10 h-10 rounded-full bg-secondary-300 flex items-center justify-center flex-shrink-0">
                      <span className="text-foreground-700 font-bold text-sm">
                        {item.user.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <div className="text-foreground-800 font-medium text-sm">{item.user.name}</div>
                      <div className="text-foreground-400 text-xs">
                        {item.user.role} · {item.user.time}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-3 mt-12 md:mt-16">
          <button className="w-10 h-10 md:w-11 md:h-11 rounded-lg border border-background-300 bg-background-50 flex items-center justify-center cursor-pointer text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="上一页">
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-foreground-900 flex items-center justify-center cursor-pointer text-white hover:bg-foreground-800 transition-colors" aria-label="下一页">
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}